import { useQuery } from '@tanstack/react-query';
import { Select, type SelectProps } from 'antd';
import { getNationalsDropdown } from 'src/apis/master_data/national.api';

type Props = SelectProps & {
  returnValueType?: 'object' | 'id' | 'code';
};

export default function NationalSelect({
  value,
  onChange,
  style,
  allowClear = true,
  placeholder,
  disabled,
  returnValueType = 'id'
}: Props) {
  const nationalsDropdownQuery = useQuery({
    queryKey: ['nationalsDropdown'],
    queryFn: () => getNationalsDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
      popupMatchSelectWidth={300}
      value={nationalsDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      options={nationalsDropdownQuery.data?.data.map((data) => ({
        value: returnValueType === 'object' ? JSON.stringify(data) : data[returnValueType],
        label: data.name,
        data: data
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={nationalsDropdownQuery.isFetching}
    />
  );
}
